import { STATUS_MSG } from "@/constant.js";

const CERTIFICATE_VALUE = infoType => {
  return {
    cfwNo: "", // 발급번호
    type: infoType.includes("biz") ? "A1" : "A2", // A1: 사업자등록번호 / A2: 표준재무제표
    checkStatus: 0, // 확인상태 - 0: 증명 전 / 1: 증명 완료 / 2: 증명 실패
    checkMsg: "", // 사업자번호, 결산월 등 확인 후 메시지
    statusMsg: "", // 오류메시지. 빈 값: 정상
    xmldata: null,
  };
};

export const state = {
  tabValue: 0, // UI - tab value
  bizno: "", // 사업자번호
  bizinfo: CERTIFICATE_VALUE("biz"), // 사업자등록증명
  fin1info: CERTIFICATE_VALUE("fin"), // 표준재무제표증명1
  fin2info: CERTIFICATE_VALUE("fin"), // 표준재무제표증명2
  fin3info: CERTIFICATE_VALUE("fin"), // 표준재무제표증명3
  infoTypeList: ["bizinfo", "fin1info", "fin2info", "fin3info"],
  agreeAll: false,
  agree1: false,
  agree2: false,
  name: "", // 제출자명
  tel: "", // 제출자 휴대전화
  certiStatus: 0, // 0: PASS 팝업 전, 1: PASS 팝업 후
  certiMsg: "",
  txvscfwissNo: "", //민원증명 발급번호
};

export const mutations = {
  SET_INIT(state) {
    state.tabValue = 0;
    state.bizno = "";
    state.bizinfo.cfwNo = "";
    state.fin1info.cfwNo = "";
    state.fin2info.cfwNo = "";
    state.fin3info.cfwNo = "";
    state.txvscfwissNo = "";
  },
  SET_TABVALUE(state, value) {
    state.tabValue = value;
  },
  SET_BIZNO(state, value) {
    const infoTypeList = state.infoTypeList;
    infoTypeList.forEach(infoType => {
      let cfwNo = state[infoType].cfwNo;
      state[infoType] = CERTIFICATE_VALUE(infoType);
      state[infoType].cfwNo = cfwNo;
    });
    state.bizno = value;
  },
  SET_BIZCFW(state, value) {
    state.bizinfo.cfwNo = value;
  },
  SET_FIN1CFW(state, value) {
    state.fin1info.cfwNo = value;
  },
  SET_FIN2CFW(state, value) {
    state.fin2info.cfwNo = value;
  },
  SET_FIN3CFW(state, value) {
    state.fin3info.cfwNo = value;
  },
  SET_TXVSCFWISSNO(state, value) {
    state.txvscfwissNo = value;
  },
  SET_INFO(state, payload) {
    const { infoType, data } = payload;
    const targetInfo = state[infoType];
    const jsonData = data && data.data ? data.data : null;
    let xmldata = data && data.xmldata ? data.xmldata : null;
    let cfwNo = jsonData ? jsonData.txvscfwissno : "";
    let checkStatus = 1; // 확인상태 - 0: 증명 전 / 1: 증명 완료 / 2: 증명 실패
    let checkMsg = ""; // A2. 결산월일 확인 후 메시지
    let statusMsg = ""; // not valid 등 메시지

    // 증명실패
    if (
      !payload ||
      !jsonData ||
      !xmldata ||
      (infoType == "bizinfo" && jsonData.txvscfwdivcd != "A1") ||
      (infoType.substr(0, 3) == "fin" && jsonData.txvscfwdivcd != "A2") ||
      !(jsonData.rescode == "00" || jsonData.rescode == "E6")
    ) {
      checkStatus = 2;
      statusMsg = STATUS_MSG.NOTVALID;
      xmldata = null;

      // 발급일로부터 90일이 경과한 경우
    } else if (jsonData.rescode == "E6") {
      checkStatus = 2;
      statusMsg = STATUS_MSG.EXPIRED;
      xmldata = null;
    } else if (jsonData.txvscfwdivcd == "A2") {
      let faBseDate = jsonData.fa_bse_date;
      checkMsg =
        "결산월일 : " +
        faBseDate.slice(0, 4) +
        "." +
        faBseDate.slice(4, 6) +
        "." +
        faBseDate.slice(6, 8);
    }

    targetInfo.cfwNo = cfwNo;
    targetInfo.checkStatus = checkStatus;
    targetInfo.checkMsg = checkMsg;
    targetInfo.statusMsg = statusMsg;
    targetInfo.xmldata = xmldata;
  },
  SET_INITINFO(state, infoType) {
    state[infoType] = CERTIFICATE_VALUE(infoType);
  },

  SET_TEL(state, value) {
    state.tel = value;
  },
  SET_CRTMSG(state, value) {
    state.certiMsg = value;
  },
  SET_CRTSTATUS(status, value) {
    state.certiStatus = value;
  },
};
